<template>
  <label class="v-switch" :class="classes" @click="handleInput(!value)">
    <span class="v-switch__mark"></span>
  </label>
</template>

<script>
/**
 * @param {Boolean} [value=false] - Значение переключателя
 * @param {Boolean} [disabled=false] - Отключить активность переключателя
 */
export default {
  name: 'VSwitch',

  props: {
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classes() {
      return {
        'v-switch--checked': this.value,
        'v-switch--disabled': this.disabled
      }
    }
  },

  methods: {
    handleInput(value) {
      if (!this.disabled) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
